module.exports = __webpack_public_path__ + "static/media/damir-bosnjak.c4cb0b89.jpg";